import React, { FC } from 'react';
import { IOption } from 'components/ui/Dropdown/Dropdown';
import { FieldRenderProps } from 'react-final-form';
import SelectTags from '../SelectTags/SelectTags';

export interface ISelectTagsWrapper extends FieldRenderProps<[]> {
  options: IOption[];
  isFullWidthTag?: boolean;
  hasAllOption?: boolean;
}

const SelectTagsWrapper: FC<ISelectTagsWrapper> = (props) => {
  const { input, render, children, ...otherProps } = props;
  return <SelectTags {...input} {...otherProps} />;
};

export default SelectTagsWrapper;
